import { IcategoriesResponse, ImasterCategoryResponse } from "../interfaces/roles.interface";

export const roleTypeTranslator = (
    t:Function,
    roleTypesObject:{
        base: ImasterCategoryResponse | undefined,
        client: ImasterCategoryResponse | undefined,
    },
    roleItem:any) =>
        t(`${Object.values(roleTypesObject).filter((roleTypeItem:any) =>
        (roleTypeItem?.id === roleItem?.roleTypeId))[0]?.label?.consoleFunctionality[0]
    }.${Object.values(roleTypesObject).filter((roleTypeItem:any) =>
    (roleTypeItem?.id === roleItem?.roleTypeId))[0]?.label?.key}`);

export const categoryTranslator = (
    t: Function,
    categoriesListBK:IcategoriesResponse[] | undefined,
    category:string
) => t(categoriesListBK?.filter((categItem:IcategoriesResponse) => (
        categItem.name === category
    ))[0]?.keyLabel);

export const permissionTranslator = (
    t: Function,
    privilegeId: string,
    permissionTypesList:ImasterCategoryResponse[],
) =>
    t(`${permissionTypesList?.find(( permissiontype: ImasterCategoryResponse )=>
        permissiontype.id === privilegeId)?.label?.consoleFunctionality[0]
    }.${permissionTypesList?.find(( permissiontype: ImasterCategoryResponse )=>
        permissiontype.id === privilegeId)?.label?.key}`);
